package com.wintermar.inspection.core.ui.component.button.variant

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

@Composable
fun ButtonVariant.toModel(): ButtonVariantModel {
    val themeColor = LocalAppTheme.current.color

    val palette = when (this) {
        ButtonVariant.SmallPrimary,
        ButtonVariant.MediumPrimary,
        ButtonVariant.LargePrimary,
        ButtonVariant.XLargePrimary,
        ButtonVariant.XXLargePrimary ->
            ButtonPaletteVariant.Primary.palette()

        ButtonVariant.SmallSecondary,
        ButtonVariant.MediumSecondary,
        ButtonVariant.LargeSecondary,
        ButtonVariant.XLargeSecondary,
        ButtonVariant.XXLargeSecondary ->
            ButtonPaletteVariant.Secondary.palette()

        ButtonVariant.SmallOutline,
        ButtonVariant.MediumOutline,
        ButtonVariant.LargeOutline,
        ButtonVariant.XLargeOutline,
        ButtonVariant.XXLargeOutline ->
            ButtonPaletteVariant.Outline.palette()

        ButtonVariant.SmallGhost,
        ButtonVariant.MediumGhost,
        ButtonVariant.LargeGhost,
        ButtonVariant.XLargeGhost,
        ButtonVariant.XXLargeGhost ->
            ButtonPaletteVariant.Ghost.palette()

        else ->
            ButtonPaletteVariant.Danger.palette()
    }

    val size = when (this) {
        ButtonVariant.SmallPrimary,
        ButtonVariant.SmallSecondary,
        ButtonVariant.SmallOutline,
        ButtonVariant.SmallGhost,
        ButtonVariant.SmallDanger ->
            ButtonSizeVariant.Small.size()

        ButtonVariant.MediumPrimary,
        ButtonVariant.MediumSecondary,
        ButtonVariant.MediumOutline,
        ButtonVariant.MediumGhost,
        ButtonVariant.MediumDanger ->
            ButtonSizeVariant.Medium.size()

        ButtonVariant.LargePrimary,
        ButtonVariant.LargeSecondary,
        ButtonVariant.LargeOutline,
        ButtonVariant.LargeGhost,
        ButtonVariant.LargeDanger ->
            ButtonSizeVariant.Large.size()

        ButtonVariant.XLargePrimary,
        ButtonVariant.XLargeSecondary,
        ButtonVariant.XLargeOutline,
        ButtonVariant.XLargeGhost,
        ButtonVariant.XLargeDanger ->
            ButtonSizeVariant.XLarge.size()

        else ->
            ButtonSizeVariant.XXLarge.size()
    }

    return remember(this, themeColor) {
        ButtonVariantModel(
            stateColor = palette,
            size = size
        )
    }
}
